import { Button } from "@/components/ui/button";
import {
  Video, VideoOff, Mic, MicOff, PhoneOff,
  Monitor, MonitorOff, UserPlus, Disc3, Square
} from "lucide-react";

/**
 * CallControls - Video call control buttons
 */
export default function CallControls({
  callState,
  isMuted,
  isCameraOff,
  isScreenSharing,
  isRecording,
  onToggleMute,
  onToggleCamera,
  onToggleScreenShare,
  onToggleRecording,
  onAddParticipant,
  onEndCall
}) {
  const isConnected = callState === "connected";
  const isActive = callState !== "idle";

  return (
    <div className="p-4 bg-gray-100 dark:bg-gray-800 flex items-center justify-center gap-3">
      <Button
        variant={isMuted ? "destructive" : "secondary"}
        size="lg"
        className="rounded-full w-14 h-14"
        onClick={onToggleMute}
        disabled={!isActive}
        title={isMuted ? "Unmute" : "Mute"}
        data-testid="mute-btn"
      >
        {isMuted ? <MicOff className="w-6 h-6" /> : <Mic className="w-6 h-6" />}
      </Button>

      <Button
        variant={isCameraOff ? "destructive" : "secondary"}
        size="lg"
        className="rounded-full w-14 h-14"
        onClick={onToggleCamera}
        disabled={!isActive}
        title={isCameraOff ? "Turn on camera" : "Turn off camera"}
        data-testid="camera-btn"
      >
        {isCameraOff ? <VideoOff className="w-6 h-6" /> : <Video className="w-6 h-6" />}
      </Button>

      {isConnected && (
        <Button
          variant={isScreenSharing ? "default" : "secondary"}
          size="lg"
          className={`rounded-full w-14 h-14 ${isScreenSharing ? "bg-blue-600 hover:bg-blue-700" : ""}`}
          onClick={onToggleScreenShare}
          title={isScreenSharing ? "Stop sharing" : "Share screen"}
          data-testid="screen-share-btn"
        >
          {isScreenSharing ? <MonitorOff className="w-6 h-6" /> : <Monitor className="w-6 h-6" />}
        </Button>
      )}

      {isConnected && (
        <Button
          variant="secondary"
          size="lg"
          className="rounded-full w-14 h-14"
          onClick={onAddParticipant}
          title="Add participant"
          data-testid="add-participant-btn"
        >
          <UserPlus className="w-6 h-6" />
        </Button>
      )}

      {isConnected && (
        <Button
          variant={isRecording ? "destructive" : "secondary"}
          size="lg"
          className="rounded-full w-14 h-14"
          onClick={onToggleRecording}
          title={isRecording ? "Stop recording" : "Start recording"}
          data-testid="record-btn"
        >
          {isRecording ? <Square className="w-6 h-6" /> : <Disc3 className="w-6 h-6" />}
        </Button>
      )}

      {isActive && (
        <Button
          variant="destructive"
          size="lg"
          className="rounded-full w-14 h-14"
          onClick={onEndCall}
          data-testid="end-call-btn"
        >
          <PhoneOff className="w-6 h-6" />
        </Button>
      )}
    </div>
  );
}
